import { render, staticRenderFns } from "./PlatformSelect.vue?vue&type=template&id=e507b298&scoped=true"
import script from "./PlatformSelect.vue?vue&type=script&lang=js"
export * from "./PlatformSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507b298",
  null
  
)

export default component.exports